/**
 * ROUNDTYPES enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ROUNDTYPES.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ROUNDTYPES {
  NONE = 0,
  PLAYER = 1,
  CREATURE = 2
};